module.exports = __webpack_public_path__ + "04_glasses_black.5222fa5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer4/04_glasses_black.png
// module id = eLMB
// module chunks = 0